import {useMutation} from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation sendUserVerification($customerId: String!) {
    sendUserVerification(customerId: $customerId) {
      statusCode
      message
    }
  }
`;

const useSendUserVerification = (onCompleted = (_data: any) => {
}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (customerId: string) => {
    return action({ variables: { customerId } });
  };
};

export default useSendUserVerification;
